/// <amd-module name="TFS/Msal/SignoutComponent" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ITfsMsalInteractiveService } from "./TfsMsalInteractiveService.types";

const meControlSignoutParameters = ["ru", "sessionId"];

class SignoutComponent extends VssComponent {
    constructor(props: any, context: IVssComponentContext) {
        super(props, context);

        const incomingQueryParameters = new URLSearchParams(window.location.search);
        const outgoingQueryParameters = new URLSearchParams();
        meControlSignoutParameters.forEach((key) => {
            const value = incomingQueryParameters.get(key);
            if (value) {
                outgoingQueryParameters.set(key, value);
            }
        });

        const msalService = context.pageContext.getService<ITfsMsalInteractiveService>("ITfsMsalInteractiveService");
        if (msalService) {
            msalService.signOut(outgoingQueryParameters);
        }
    }

    public render(): JSX.Element {
        return <div></div>
    }
}

VssComponent.register("ms.vss-tfs-web.signout-component", SignoutComponent);
